export const NUMBER_TO_BOOL_MAP = {
  0: false,
  1: true,
};

export enum QUIZ_IDS {
  rent = 1,
  buy,
  company,
  apartments,
}

export enum APP_IDS {
  mcity = 1,
  apartments,
  office,
  invest,
}

export enum PAGE_IDS {
  BrokerPage = 1,
  Quiz,
  Landing,
  LandingOffice,
  NewQuiz,
  Complex,
  About,
  NotFound,
  RentQuiz,
  RentQuizWithTable,
  BuyQuiz,
  CompanyQuiz,
  RentCalculator,
  SearchPage,
  CallMe,
  detail,
  contact,
  calc,
}

export enum COMPONENT_IDS {
  CallMeSidebarForm = 1,
  CallMe,
  CallMeFirst,
  CallMeSecond,
  CallMeSection,
  ModalConnect,
  Modal,
  ObjectDetails,
  ObjectDetailsWithGalleryAndPreviewButtons,
  PreviewForm,
  ObjectDetailsWithGalleryAndLikes,
  ResultsForm,
  ResultsStep,
  ResultsStepWithTable,
  ResultsWithoutObjects,
  Listing,
  SubscriptionSection,
  ComplexInfoSection,
  MainMenu,
  PartnersSection,
  LockedOffersSection,
  CaseSection,
  TableFilter,
  ApartmentFilter,
  FilterSection,
  FindApartmentsQuizResultsStep,
  rentResultsStepWithTable,
  CalculatorSection,
  Search,
  SearchOffice,
  buyResultsStep,
  rentResultsStep,
  companyResultsStep,
  ContactForm,
  calc,
  filter_static,
  preview_form,
  relevance,
  search,
  table_filter,
  MoreInfoForm,
}

export interface UiId {
  appId?: APP_IDS;
  pageId?: PAGE_IDS;
  componentId?: COMPONENT_IDS;
}

export interface UiIdStr {
  appId?: keyof typeof APP_IDS;
  pageId?: keyof typeof PAGE_IDS;
  componentId?: keyof typeof COMPONENT_IDS;
}

export interface UiIds {
  appIds: APP_IDS[];
  pageIds: PAGE_IDS[];
  componentIds: COMPONENT_IDS[];
}
